import { Tabs, Text } from '@chakra-ui/react';
import { DraggablePanel } from '@components/ui/draggable';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectTargetById } from '@redux/situation/situation.selectors';
import { FormattedMessage } from 'react-intl';

import { Target } from '@/types/c2/c2.types';
import { PopupComponentProps, PopupTypeEnum } from '@/types/popup.types';
import { TargetLocation } from '@/types/sensor/sensor.types';
import { SensorTypeEnum } from '@/types/sensor/sensors';

import DroneControlCommands from './DroneControlCommands';
import DroneControlPayload from './DroneControlPayload';

export function DroneControlPopup({
  data,
  mapConstraintsRef,
  top,
  left,
  onClose,
}: Readonly<PopupComponentProps<PopupTypeEnum.DRONE_CONTROL>>) {
  const { targetId } = data;
  const target: Target<TargetLocation> | undefined = useSelectorWithReplayMode(selectTargetById, targetId);
  const groundStationTrack = target?.trackIds.find((track) => track.sensorType === SensorTypeEnum.GROUND_STATION);

  if (!target || groundStationTrack === undefined) {
    onClose();
    return null;
  }

  return (
    <DraggablePanel.Root constraintsRef={mapConstraintsRef} top={top} left={left}>
      <DraggablePanel.Header onClose={onClose}>
        <FormattedMessage id="droneControl.title" />
      </DraggablePanel.Header>
      <DraggablePanel.Body width={431}>
        <Tabs.Root
          variant="neutral"
          size="md"
          gap={0.25}
          lazyMount
          defaultValue="commands"
          backgroundColor="neutral.900"
        >
          <Tabs.List>
            <Tabs.Trigger value="commands">
              <Text>
                <FormattedMessage id="droneControl.tab.commands.title" />
              </Text>
            </Tabs.Trigger>
            <Tabs.Trigger value="payload">
              <Text>
                <FormattedMessage id="droneControl.tab.payloads.title" />
              </Text>
            </Tabs.Trigger>
          </Tabs.List>
          <Tabs.ContentGroup>
            <Tabs.Content value="commands">
              <DroneControlCommands target={target} groundStationTrack={groundStationTrack} />
            </Tabs.Content>
            <Tabs.Content value="payload">
              <DroneControlPayload target={target} groundStationTrack={groundStationTrack} />
            </Tabs.Content>
          </Tabs.ContentGroup>
        </Tabs.Root>
      </DraggablePanel.Body>
    </DraggablePanel.Root>
  );
}
